import webapi from "../webapi";
export function getTopKeywords(payload, options) {
    return webapi("api/v1/topKeywords/recommend", Object.assign({}, payload), options);
}
export function getCategories(payload, options) {
    return webapi("api/v1/categories/VelaHomePageCategories", Object.assign({}, payload), options);
}
export function getCartstore(payload, options) {
    return webapi("api/v1/cartstore/get", Object.assign({}, payload), options);
}
export function getKeywordsAutocomplete(payload = {}, options = {}) {
    return webapi("api/v1/rest.app/vela/keywordsAutocomplete/vela.keywords.autocomplete.get", Object.assign({}, payload), Object.assign({}, options));
}
export function getCountries(payload = {}, options = {}) {
    return webapi("api/v1/rest.app/vela/GetV2Countries/vela.sys.countries.get.v2", Object.assign({}, payload), Object.assign({}, options));
}
export function getCurrencies(payload = {}, options = {}) {
    return webapi("api/v1/rest.app/vela/GetCurrencies/vela.sys.currencies.get", Object.assign({}, payload), Object.assign({}, options));
}
export function getLanguages(payload = {}, options = {}) {
    return webapi("api/v1/rest.app/vela/GetLanguages/vela.sys.languages.get", Object.assign({}, payload), Object.assign({}, options));
}
export function getUserProfile(payload = {}, options = {}) {
    return webapi("api/v1/rest.app/vela/GetUserProfile/vela.user.profile.get", Object.assign({}, payload), Object.assign({}, options));
}
export function getUnPaidOrder(payload = {}, options = {}) {
    return webapi("api/v1/rest.app/vela/GetUnpaidOrder/vela.orders.get", Object.assign(Object.assign({}, payload), { status_type: "1", page_size: "1", page_no: "1" }), Object.assign({}, options));
}
export function userLoginout(payload = {}, options = {}) {
    return webapi("api/v1/rest.app/vela/UserLoginout/vela.user.logoff", Object.assign({}, payload), Object.assign({}, options));
}
export function getKeywordSearch(payload, options) {
    return webapi("api/v1/search/keywordSearch", Object.assign({}, payload), options);
}
export function getInfo(payload, options) {
    return webapi("api/v1/namespace/getInfo/vela.sys.countries.get.v2", Object.assign({}, payload), options);
}
export default {
    getTopKeywords,
    getCategories,
    getCartstore,
    getKeywordSearch,
    getInfo
};
